import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, Col, FormFeedback } from 'reactstrap';
import { SelectButton } from 'primereact/selectbutton';
import { Button } from 'primereact/button';
import {
  FreezeUI,
  UnfreezeUI,
} from './../../../assets/plugins/nucleo/js/freeze-ui';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { FiChevronRight } from 'react-icons/fi';
import SelectTeam from '../SelectTeam';
import { teamActionTypes } from '@store/Team/Team.actionTypes';
import styles from './SelectComapny.module.scss';
import classNames from 'classnames';
export default function SelectCompany() {
  const teamReducer = useSelector((state) => ({
    selectTeams: state.team.selectTeams,
    companiesWithSubscription: state.team.companiesWithSubscription,
    subscriptionLoading: state.team.subscriptionLoading,
  }));
  const history = useHistory();
  const authState = useSelector((state) => ({ ...state.auth }));
  const isUserAuthorized = authState.authorized;
  const companyList = authState.profile?.companyList ?? [];
  const [selectedCompany, setCompany] = useState();
  const [error, setError] = useState({ isError: false, msg: '' });
  const dispatch = useDispatch();

  useEffect(() => {
    localStorage.setItem('teamData', []);
    // Redirect unAuthorized users to home page
    if (!authState.loading && !isUserAuthorized) {
      history.push('/');
    }
    if (authState.loading) FreezeUI();
    if (!authState.loading) UnfreezeUI();
  }, [authState]);

  // NEW: Fetch subscription status using saga
  useEffect(() => {
    if (companyList.length > 0) {
      dispatch({
        type: teamActionTypes.GET_COMPANIES_WITH_SUBSCRIPTION,
        payload: { companyList },
      });
    }
  }, [companyList, dispatch]);

  const itemTemplate = (option) => {
    const company = teamReducer.companiesWithSubscription.find(
      (c) => c.companyId === option.companyId
    );
    const subscriptionStatus = company?.subscriptionStatus || 'trial';
    // A Client is an external, read-only viewer of this company — its
    // billing/subscription health is not their concern to see.
    const isClientOfThisCompany = option.role === 'Client';

    const getStatusBadge = (status) => {
      switch (status) {
        case 'suspended':
          return <span className="badge badge-danger ml-2">Suspended</span>;
        case 'trial':
          return <span className="badge badge-warning ml-2">Trial</span>;
        case 'active':
          return <span className="badge badge-success ml-2">Active</span>;
        default:
          return <span className="badge badge-secondary ml-2">Unknown</span>;
      }
    };

    return (
      <div
        className={classNames(styles.selectCompanyItem, 'd-flex')}
        style={{
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          textTransform: 'capitalize',
        }}
      >
        <div className="d-flex align-items-center">
          <div className="font-weight-bold">{option.companyName}</div>
          {!isClientOfThisCompany && getStatusBadge(subscriptionStatus)}
        </div>
        <div>
          <FiChevronRight size={21} />
        </div>
      </div>
    );
  };

  const handleNavigation = () => {
    if (!selectedCompany) {
      setError({
        isError: true,
        msg: 'Please select at least one of the companies.',
      });
    } else {
      const selectedCompanyData = teamReducer.companiesWithSubscription.find(
        (c) => c.companyId === selectedCompany
      );

      console.log('Subscription: User selected company:', selectedCompany);
      console.log('Subscription: Selected company data:', selectedCompanyData);

      // Check subscription status before allowing access
      // if (selectedCompanyData?.subscriptionStatus === 'suspended') {
      //   console.log('Subscription: Selected company is suspended, redirecting');
      //   // Redirect to suspended page with company context
      //   history.push(`/subscription-suspended?companyId=${selectedCompany}`);
      //   return;
      // }

      console.log(
        'Subscription: Dispatching SWITCH_COMPANY_ACTIVE_TEAM with payload:',
        {
          companyId: selectedCompany,
          userId: authState?.profile?.id,
        }
      );

      try {
        dispatch({
          type: teamActionTypes.SWITCH_COMPANY_ACTIVE_TEAM,
          payload: {
            companyId: selectedCompany,
            userId: authState?.profile?.id,
          },
        });
      } catch (error) {
        console.error('Subscription: Error dispatching company switch:', error);
        return error;
      }
    }
  };

  if (teamReducer.subscriptionLoading) {
    return (
      <div className={styles.selectCompanyContainer}>
        <Col lg="5" md="7">
          <Card className="bg-secondary border-0">
            <CardBody className="text-center p-5">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <p className="mt-3 text-muted">Loading companies...</p>
            </CardBody>
          </Card>
        </Col>
      </div>
    );
  }

  console.log(teamReducer.selectTeams.data);
  return (
    <div className={styles.selectCompanyContainer}>
      {teamReducer?.selectTeams?.data?.length > 0 ? (
        <SelectTeam />
      ) : (
        <Col lg="5" md="7">
          <Card className="bg-secondary border-0">
            <CardHeader className="bg-transparent p-0 m-0 border-0">
              <div className="text-muted text-center mt-2 mb-3">
                <h2>Select a company</h2>
                <small>
                  Select any company to navigate to the relevant dashboard.
                </small>
              </div>
            </CardHeader>
            <CardBody className={styles.selectCompanyCardBody}>
              <SelectButton
                optionLabel="companyName"
                optionValue="companyId"
                className="company_select-btn with-scroll"
                itemTemplate={itemTemplate}
                options={teamReducer.companiesWithSubscription}
                value={selectedCompany}
                onChange={(e) => setCompany(e.value)}
              ></SelectButton>
              {error.isError && (
                <FormFeedback className="d-block text-center">
                  {error.msg}
                </FormFeedback>
              )}
              <div className="w-100 text-center mt-3">
                <Button
                  type="button"
                  onClick={() => handleNavigation()}
                  label="Navigate"
                  className="p-button p-button-secondary"
                  icon="pi pi-arrow-right"
                  iconPos="right"
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      )}
    </div>
  );
}
